import RestrictMoveAndRotate from "./features/restrict-moveAndRotate";
import RestrictHighlight from "./features/restrict-highlight";
import RestrictVisibility from "./features/restrict-visibility";
import RestrictTransparency from "./features/restrict-transparency";

class MeshRestrictionController {
    constructor() {
        {
            this.restrictionControllers = {
                MoveAndRotate: new RestrictMoveAndRotate(),
                Highlight: new RestrictHighlight(),
                Visibility: new RestrictVisibility(),
                Transparency: new RestrictTransparency()
            }
        }
    }

    updateUserActionMoveObjectsRetainColor(retainColor) {
        const controller = this.restrictionControllers.MoveAndRotate;
        if (controller) {
            controller.updateUserActionMoveObjectsRetainColor(retainColor);
        }
    }

    retainColorForUserActionMoveObjects() {
        const controller = this.restrictionControllers.MoveAndRotate;
        return controller ? controller.retainColorForUserActionMoveObjects : false;
    }

    updateRules(restrictionType = undefined, rules = [], applyTo = []) {
        const controller = this.restrictionControllers[restrictionType];
        if (controller) controller.updateRules(rules, applyTo);
    }

    isValid(restrictionType = undefined, restrictedMeshType = undefined, meshList = []) {
        const controller = this.restrictionControllers[restrictionType];
        return controller ? controller.isValid(restrictedMeshType, meshList) : true;
    }

    updateRestrictionStatus(restrictionType = undefined, status) {
        const controller = this.restrictionControllers[restrictionType];
        if (controller) controller.updateRestrictionStatus(status);
    }

    clear(restrictionType = undefined) {
        const controller = this.restrictionControllers[restrictionType];
        if (controller) controller.clear();
    }
}

let meshRestrictionController = new MeshRestrictionController();

export default meshRestrictionController;